export default __webpack_public_path__ + "static/media/ttaVerifiedBadge.a4fd4a0f.svg";